/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedSociosIndexRouteImport } from './routes/_authed/socios/index'
import { Route as AuthedSociosSlugRouteImport } from './routes/_authed/socios/$slug'

const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSociosIndexRoute = AuthedSociosIndexRouteImport.update({
  id: '/socios/',
  path: '/socios/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSociosSlugRoute = AuthedSociosSlugRouteImport.update({
  id: '/socios/$slug',
  path: '/socios/$slug',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/socios/$slug': typeof AuthedSociosSlugRoute
  '/socios/': typeof AuthedSociosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-in': typeof SignInRoute
  '/socios/$slug': typeof AuthedSociosSlugRoute
  '/socios': typeof AuthedSociosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authed/socios/$slug': typeof AuthedSociosSlugRoute
  '/_authed/socios/': typeof AuthedSociosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/sign-in' | '/socios/$slug' | '/socios/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/sign-in' | '/socios/$slug' | '/socios'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/sign-in'
    | '/_authed/socios/$slug'
    | '/_authed/socios/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/socios/': {
      id: '/_authed/socios/'
      path: '/socios'
      fullPath: '/socios/'
      preLoaderRoute: typeof AuthedSociosIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/socios/$slug': {
      id: '/_authed/socios/$slug'
      path: '/socios/$slug'
      fullPath: '/socios/$slug'
      preLoaderRoute: typeof AuthedSociosSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedSociosSlugRoute: typeof AuthedSociosSlugRoute
  AuthedSociosIndexRoute: typeof AuthedSociosIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedSociosSlugRoute: AuthedSociosSlugRoute,
  AuthedSociosIndexRoute: AuthedSociosIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
